import React, { ReactNode } from 'react';

interface Props {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
  overlay?: ReactNode;
}

const ChatPanel: React.FC<Props> = ({ header, body, footer, overlay }) => (
  <div className="bot-panel">
    {header}
    <div className="bot-panel__body">{body}</div>
    {footer}
    {overlay}
  </div>
);

export default ChatPanel;
